<template>
  <div>
    <QBanner
      dense
      rounded
    >
      <span
        class="cursor-pointer underline"
        @click="openVersionsControlModal"
      >
        Last edit was made {{ updatedAt(latestVersion) }}
        {{ userName(latestVersion) }}

        <StreemTooltip> Show version history </StreemTooltip>
      </span>
    </QBanner>
  </div>
</template>

<script>
import { fromNow } from "shared/helpers/date";

export default {
  name: "VersionControlBar",
  props: {
    modalWidth: {
      type: String,
      default: "",
    },
    versions: {
      type: Array,
      required: true,
    },
    hasFeature: {
      type: Boolean,
    },
    extraLabel: {
      type: String,
      default: "",
    },
  },
  computed: {
    latestVersion() {
      return this.versions[0];
    },
  },
  methods: {
    updatedAt(version) {
      return fromNow(version.createdAt);
    },
    openVersionsControlModal() {
      this.$modals.open("VersionControlModal", {
        props: {
          modalWidth: this.modalWidth,
          versions: this.versions,
          hasFeature: this.hasFeature,
          extraLabel: this.extraLabel,
        },
      });
    },
    userName(version) {
      if (version.user && version.user.name) {
        return `by ${version.user.name}`;
      }

      return null;
    },
  },
};
</script>

<style lang="scss" scoped>
.q-banner {
  background-color: #d0f0c0;
}

:deep(.q-banner__content) {
  color: grey;
}
</style>
